// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"antd-pro-containers-dairy-contact-all-styles-checkBox","radioButton":"antd-pro-containers-dairy-contact-all-styles-radioButton"};